import LiveBlogCoverSpread from './LiveBlogCoverSpread';

export default LiveBlogCoverSpread;
